import { render, staticRenderFns } from "./SAccContributorsBlock.vue?vue&type=template&id=5d743d37&scoped=true"
import script from "./SAccContributorsBlock.vue?vue&type=script&lang=ts"
export * from "./SAccContributorsBlock.vue?vue&type=script&lang=ts"
import style0 from "./SAccContributorsBlock.vue?vue&type=style&index=0&id=5d743d37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d743d37",
  null
  
)

export default component.exports